import PubSub from "pubsub-js";

import PubSubTopics from "../constants/pubSubTopics";
import {
  isNativeCommsInstalled,
  messageTypes as nativeCommsBroadcastMessageTypes} from "../nativeComms/nativeCommsBroadcaster";

const trackEvent = (action = null, category = null, label = null, value = null) => {
  //#!if ENV === "production" && harvard !== true
// if (isNativeCommsInstalled()) {
// PubSub.publish(PubSubTopics.sendNativeMessage, {
// msg: nativeCommsBroadcastMessageTypes.TRACK_EVENT,
// action: action,
// category: category,
// label: label,
// value: value
// });
// } else if (window.gtag) {
// window.gtag("event", action, { category: category, label: label, value: value });
// }
  //#!endif
};

export { trackEvent };
